import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Grupo } from '../../models/grupo';
import { GrupoService } from '../../services/grupo.service';

@Component({
	selector: 'app-password',
	templateUrl: './password.component.html',
	styleUrls: ['./password.component.css'],
	providers: [GrupoService]
})
export class PasswordComponent implements OnInit {
	public status: string;
	public message_success: string;
	public message_error: string;
	public token;
	public identity;
	public grupo: Grupo
	public code: any
	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService
	) {
		this.token = this._grupoService.getToken();
		this.identity = this._grupoService.getIdentity();
		this.grupo = new Grupo(1, 1, '', '', '', '', '', '', '', '', 1);
	}

	ngOnInit() {
		this._route.params.subscribe(params => {
			// convertir a entero
			this.code = params['code'];
			this._grupoService.validateCode(this.code).subscribe(
				response => {

				}, error => {
					this._router.navigate(['login'])
				}
			)
		})
	}

	changePassword() {

		let password = $("#password").val()
		let repassword = $("#repassword").val()
		let data = { password: password, code: this.code, repassword: repassword }

		this._grupoService.changePassword(data).subscribe(
			response => {
				$(".alert").show();
				this.status = 'success'
				this.message_success = response.message
				setTimeout(function () {
					$(".alert").fadeTo(500, 1).slideUp(500, function () {
						$(".alert").hide();
					});
				}, 3000);
				location.href = "login";
			},
			error => {
				$(".alert").show();
				if (error.status == 400) {
					this.status = 'error'
					this.message_error = error.error.message
					setTimeout(function () {
						$(".alert").fadeTo(500, 1).slideUp(500, function () {
							$(".alert").hide();
						});
					}, 3000);
				} else {
					this.status = 'error'
					this.message_error = 'Existen problemas con el servidor, intente más tarde'
				}
			}
		);
	}

}
